<template>
  <header class="sticky top-0 z-50 bg-white/80 dark:bg-gray-950/80 backdrop-blur-sm border-b border-zinc-100 dark:border-zinc-800">
    <div class="px-8 h-14 flex items-center justify-between">
      <a :href="isAuthenticated ? '/dashboard' : '/'" class="logo-link flex items-center">
        <img src="../assets/icons/cv-tool-gold.png" alt="cv-tool.com Logo" class="hidden sm:block h-7 w-auto" />
        <img src="../assets/icons/mobile-logo.png" alt="cv-tool.com Logo" class="block sm:hidden h-7 w-auto" />
      </a>
      <div class="flex items-center gap-3">
        <slot name="actions"></slot>
        <div v-if="!isAuthenticated">
          <a href="/login" class="text-sm text-zinc-500 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white transition-colors">
            Log in
          </a>
        </div>
        <UserDropdown
          v-else
          :current-user="currentUser"
          @logout="$emit('logout')"
        />
      </div>
    </div>
  </header>
</template>

<script>
import UserDropdown from './UserDropdown.vue'

export default {
  name: 'CvHeader',
  components: {
    UserDropdown
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    currentUser: {
      type: Object,
      default: null
    }
  },
  emits: ['logout']
}
</script>
